import React from "react";
import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaThLarge } from "react-icons/fa";
import { Seller } from "../Components";

const GalaxiaDreams = () => {
  return (
    <>
      <div className="title-bar-wrapper">
        <Container>
          <Row>
            <div className="title">
              <h1>Galaxia Dreams</h1>
            </div>
            <ul className="bread-crumb pull-right">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>-</li>
              <li>Galaxia Dreams</li>
            </ul>
          </Row>
        </Container>
      </div>
      <div className="inner-page-bg">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="why-projects">
                <div className="why-projects-title">
                  <h2>Why Zeeshan Galaxia Dreams?</h2>
                  <div className="why-projects-dec">
                    Project is only 5 minutes from Airport.
                  </div>
                  <div className="why-projects-dec">
                    Project is 2-3 minutes away from vip road Kaikhali Bus Stop.
                  </div>
                  <div className="why-projects-dec">
                    BANK OFFER- HDFC, IDBI, LIC HOUSING FINANCE, Standard
                    Chartered Bank,ICICI Bank and IIFL Finance Limited.
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>Zeeshan Galaxia Dreams Overview</h2>
                <div className="overview-main">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Area</span>
                          <p className="mb-0">0.09 Acres</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Sizes</span>
                          <p className="mb-0">407.00 sq.ft. - 1606.00 sq.ft.</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Project Size</span>
                          <p className="mb-0">1 Building - 15 units</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Avg. Price</span>
                          <p className="mb-0">4.00 K/sq.ft</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Possession Startse</span>
                          <p className="mb-0">May, 2023</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="overview-single d-flex align-items-center">
                        <div className="overview-icon">
                          <FaThLarge />
                        </div>
                        <div>
                          <span>Configurations</span>
                          <p className="mb-0">1, 2, 3, 4 BHK Apartments</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="group-all-btn">
                    <button>View as 99</button>
                    <button>View as Magic Bricks</button>
                    <button>View as Xyz</button>
                  </div>
                </div>
              </div>
              <div className="overview-details">
                <h2>About Zeeshan Galaxia Dreams</h2>
                <div className="overview-main about-for-project">
                  <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Dignissimos, nemo. Laudantium, vero minima. Dolorem officiis
                    reiciendis perspiciatis dolorum, ipsa pariatur hic totam
                    harum velit, maiores aut voluptatum nihil consectetur ab.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <Seller />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default GalaxiaDreams;
